<ng-container *ngIf="worksheets$ | withLoading | async as worksheets">
  <ng-container *ngIf="worksheets.data">
    <div class="container" [ngClass]="!isList ? 'p-0' : ''">
      <div *ngFor="let worksheetGroup of worksheets.data">
        <ng-container *ngIf="worksheetGroup.Items?.length > 0">
          <div [class.row]="isList">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == 2">
                <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item
              ></ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="container" [ngClass]="!isList ? 'p-0' : ''">
      <div *ngFor="let worksheetGroup of worksheets.data">
        <ng-container *ngIf="worksheetGroup.Items?.length > 0">
          <h2 class="card-header fw-bold border-0 px-2 pb-0 text-white mt-2 mt-lg-3">
            {{ 'worksheet.gallery.images' | translate }}
          </h2>
          <div [class.row]="isList">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType != 2">
                <div [class.col-lg-4]="isList">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- No Data available -->
  <ng-container *ngIf="worksheets.isEmpty"> <p>No worksheet available</p></ng-container>

  <!-- Error -->
  <ng-container *ngIf="worksheets.error">
    <p>Error {{ worksheets.error }}</p>
  </ng-container>

  <!-- Loading -->
  <ng-container *ngIf="worksheets.isLoading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
</ng-container>
